import React, { Component } from 'react';

import ExpansionPanel from '@material-ui/core/ExpansionPanel';
import ExpansionPanelSummary from '@material-ui/core/ExpansionPanelSummary';
import ExpansionPanelDetails from '@material-ui/core/ExpansionPanelDetails';
import Typography from '@material-ui/core/Typography';
import { withStyles } from '@material-ui/core/styles';

import ExpandMoreIcon from '@material-ui/icons/ExpandMore';
import grey from '@material-ui/core/colors/grey';

import { Bids, Templates, Template, Info } from './Header';
import { VerticalDivider } from '../../Dividers';

const styles = theme => ({
  root: {
    flexGrow: 1,
  },
  details: {
    display: 'flex',
    flexDirection: 'row',
  },
  panel: {
    backgroundColor: grey[600],
  },
})

class BidsHeader extends Component {
  constructor(props) {
    super(props);
    this.state = {
      expanded: true,
    }
  }


  render() {
    const { classes } = this.props;
    const { expanded } = this.state;

    return(
      <div className={classes.root}>
        <ExpansionPanel
          className={classes.panel}
          expanded={expanded}
          onChange={() => {
            this.setState((state) => {
              return {expanded: !state.expanded}
            })
          }}>
          <ExpansionPanelSummary expandIcon={<ExpandMoreIcon />}>
            <Typography>Select a Bid Type</Typography>
          </ExpansionPanelSummary>
          <ExpansionPanelDetails>
            <Template type="simple"/>
            <VerticalDivider />
            <Template type="recurring"/>
            <VerticalDivider />
            <Template type="full"/>
          </ExpansionPanelDetails>
        </ExpansionPanel>
      </div>
    );
  }
}

export default withStyles(styles)(BidsHeader);



// WEBPACK FOOTER //
// ./src/components/admin/Bids/BidsHeader.jsx